import { DialogTitle, DialogContent, DialogContentText, IconButton, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, tableCellClasses, Grid, Button, Typography } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { styled } from '@mui/material/styles';
import { Formik, Form } from 'formik';
import SelectFieldWithSearch from '../../../../../../components/Form/SelectFieldWithSearch';
import { useState, useEffect } from 'react';
import { getCancelReasons } from '../../../../../../service/order/orderService';
import { notifyError } from '../../../../../../components/ToastContainer/Toast/Toast';
import { getInvoiceById } from '../../../../../../service/Invoice/invoice';
import * as Yup from 'yup';

export default function RtoForm({ handleClose, invoiceId }) {
    const [cancelOptions, setCancelOptions] = useState([]);
    const [invoiceData, setInvoiceData] = useState<InvoiceData | null>(null);

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));

    const fetchInvoiceList = async () => {
        try {
            const response = await getInvoiceById(invoiceId);
            if (response.status === 200) {
                setInvoiceData(response.data.data)
            }
        }
        catch (error) {
            notifyError("Something went wrong!")
        }
    }

    const fetchCancelReasons = async () => {
        try {
            const response = await getCancelReasons();
            if (response) {
                const formattedOptions = response.data.data.map((item: any) => ({
                    label: item.reason,
                    value: item.id,
                }));
                setCancelOptions(formattedOptions);
            }
        } catch (error) {
            notifyError("Something went wrong!")
        }
    };

    useEffect(() => {
        fetchInvoiceList();
        fetchCancelReasons();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <DialogTitle sx={{ pr: 5 }}>
                RTO Delivery Process
                <IconButton
                    onClick={handleClose}
                    aria-label="close"
                    sx={{
                        position: 'absolute',
                        top: 10,
                        right: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers sx={{backgroundColor: 'white'}}>
                <DialogContentText component="div">
                    <Box sx={{ overflowX: 'auto', color: '#0b0e14' }}>
                        <Grid container sx={{ mt: 1, mb: 2, display: 'flex', justifyContent: 'space-between' }}>
                            <Grid item>
                                <strong>Invoice Id : </strong>{invoiceData?.id}
                            </Grid>
                            <Grid item>
                                <strong>Order Id : </strong>{invoiceData?.order_id}
                            </Grid>
                        </Grid>
                        <TableContainer component={Paper} sx={{
                            border: '.5px solid #0b0e14',
                            borderRadius: '10px',
                            overflow: 'hidden',
                        }}>
                            <Table sx={{ minWidth: 600 }} aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Product Name</StyledTableCell>
                                        <StyledTableCell align="center">Quantity</StyledTableCell>
                                        <StyledTableCell align="center">Price&nbsp;(₹)</StyledTableCell>
                                        <StyledTableCell align="center">Amount&nbsp;(₹)</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {invoiceData?.items.map((itemData) => (
                                        <StyledTableRow>
                                            <StyledTableCell component="th" scope="row">
                                                {itemData.product_name}
                                            </StyledTableCell>
                                            <StyledTableCell align="center">{itemData.quantity}</StyledTableCell>
                                            <StyledTableCell align="center">{itemData.original_price.toFixed(2)}</StyledTableCell>
                                            <StyledTableCell align="center">{itemData.price.toFixed(2)}</StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Grid container sx={{ mt: 2 }}>
                            <Grid item>
                                <strong>Delivery Details : </strong>
                                <Typography>{invoiceData?.customer?.name}</Typography>
                                <Typography>{invoiceData?.shipping?.address1},&nbsp;{invoiceData?.shipping?.address2},
                                    &nbsp;{invoiceData?.shipping?.address3},&nbsp;{invoiceData?.shipping?.state},
                                    &nbsp;{invoiceData?.shipping?.city},&nbsp;{invoiceData?.shipping?.pincode}</Typography>
                                <Typography>
                                    <strong>Email : </strong>{invoiceData?.customer.email}
                                </Typography>
                                <Typography>
                                    <strong>Phone : </strong>{invoiceData?.customer.phone}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Formik
                            initialValues={{ cancelReason: '' }}
                            validationSchema={Yup.object().shape({
                                cancelReason: Yup.string().required('Cancel reason is required'),
                            })}
                            onSubmit={(values) => {
                                const existing = JSON.parse(localStorage.getItem('rtoCancelReason') || '[]');
                                const filtered = existing.filter((item:any) => item.invoiceId !== invoiceId);
                                filtered.push({ [invoiceId]: values.cancelReason });
                                localStorage.setItem('rtoCancelReason', JSON.stringify(filtered));
                                handleClose();
                            }}
                        >
                            {({ values, handleChange, setFieldValue }) => (
                                <Form>
                                    <Box sx={{ color: '#0B0E14', mt: 2, mb: 2 }} >
                                        <Grid container>
                                            <Grid item md={12}>
                                                <SelectFieldWithSearch
                                                    name="cancelReason"
                                                    label="Select Cancel Reason"
                                                    options={cancelOptions}
                                                    value={values.cancelReason}
                                                    isRequired
                                                    size="middle"
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }} gap={2}>
                                        <Button type="submit" variant="contained" color="primary">
                                            Cancel Shipment
                                        </Button>
                                    </Box>
                                </Form>
                            )}
                        </Formik>
                    </Box>
                </DialogContentText>
            </DialogContent >
        </>
    );
}
